module.exports = __webpack_public_path__ + "media/images/cleaning/pro2@2x-c4ae94ac9746e34451fc06713573d85d.jpg";